import { useEffect, useState } from "react";
import styles from "./tire-size-preview.module.scss";

function TireSizePreview(props: any) {
  const { calculatedSize } = props;
  const [diameter, setDiameter] = useState(null);
  const [tireDiameter, setTireDiameter] = useState(null);
  const [tireWidth, setTireWidth] = useState(null);
  const [sideWall, setSideWall] = useState(null);

  useEffect(() => {
    if (calculatedSize) {
      calculateTireSizePreview();
    }
  }, [props.calculatedSize]);

  function calculateTireSizePreview() {
    setDiameter(calculatedSize.substr(-2));
    // (There are 25.4mm to an inch)
    const subString = parseInt(calculatedSize.substring(0, 3), 10);
    const dia = subString / 25.4;
    setTireWidth(dia.toFixed(1));

    // .35 (aspect ratio)
    const sideWallCal = dia * 0.35;
    setSideWall(sideWallCal.toFixed(1));

    const tireDiaCal = (sideWallCal * 2) + parseInt(calculatedSize.substr(-2), 10);
    setTireDiameter(tireDiaCal.toFixed(1));
  }

  return (
    <div>

      <div className={styles.calculation_result}>

        <div className={styles.wheel_front_preview}>

          <div className={styles.wheel_front_preview_inner} data-width={tireWidth}>

            <span className={styles.wheel_side_preview_number} />

            <span className={styles.dimension_line} data-diameter={tireDiameter} />

            <div className={`${styles.wheel_img} ${styles.front}`} />
          </div>
        </div>

        <div className={styles.wheel_side_preview}>

          <div className={styles.wheel_side_preview_inner}>

            <div className={styles.wheel_side_preview_rim_diameter_value}>

              <div className={styles.value}>
                {diameter}
                ″
              </div>
            </div>

            <span className={styles.wheel_side_preview_number} />

            <div className={styles.wheel_side_preview_sidewall_value}>

              <span className={styles.value}>
                {sideWall}
                ″
              </span>
            </div>

            <div className={`${styles.wheel_img}  ${styles.side_arrow}`} />

            <div className={styles.wheel_img_wrap}>

              <div className={`${styles.wheel_img} ${styles.wheel}`} />
            </div>
            {/* <span className="circum-value">67.6″</span> */}
          </div>
        </div>
      </div>

      <div className={styles.wheel_size_parameters}>

        <span className={`${styles.param} ${styles.diameter}`}>
          {tireDiameter}
          ″
        </span>

        <span className={`${styles.param} ${styles.width}`}>
          {tireWidth}
          ″
        </span>

        <span className={`${styles.param} ${styles.sidewall}`}>
          {sideWall}
          ″
        </span>
      </div>
    </div>
  );
}

export default TireSizePreview;
